module.exports = __webpack_public_path__ + "static/media/stp_card_visa.782a8692.png";